<template>
  <div>
    <Loader :loaded="promotions" :marginTop="25" />
    <XsPromotions v-if="$vuetify.breakpoint.xsOnly" />
    <Promotions v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/UI/Loader.vue";
import Promotions from "@/components/Promotions/Promotions.vue";
import XsPromotions from "@/components/Promotions/Xs/Promotions.vue";

export default {
  name: "PromotionsView",
  components: { Loader, Promotions, XsPromotions },
  computed: {
    ...mapGetters({ promotions: "promotions/promotions" }),
  },
};
</script>
